import { call, put, takeLatest } from 'redux-saga/effects';
import * as actions from '@/store/slices/reconciliation.slice'; // Import your action creators
import * as api from '@/services/reconciliation'; // Import your API functions
import { PayloadAction } from '@reduxjs/toolkit';
import { isBoolean } from 'lodash';
import { IApiResponse } from '@/services/market/market.type';
import { GET_RECONCILIATION_ACTION_TYPE } from '@/constant/reconciliation/reconciliation.constant';

// Define action types
export interface GetReconciliationssAction extends PayloadAction<number> {
  type: 'reconciliation/getReconciliations';
}

function* getReconciliations(action: GetReconciliationssAction): Generator {
  try {
    const response: any = yield call(api.fetchReconcilitions as any, action?.payload);
    if (isValidReconciliationsResponse(response?.data)) {
      yield put(actions.getReconciliationsSuccess(response?.data));
    } else {
      yield put(actions.getReconciliationsFailure(response?.data));
    }
  } catch (error: any) {
    yield put(
      actions.getReconciliationsFailure(
        error?.response?.data || { message: error?.message },
      ),
    );
  }
}

function isValidReconciliationsResponse(response: IApiResponse): boolean {
  return (
    isBoolean(response.success) &&
    response.message === 'Successfully got reconciliations.'
  );
}

function* reconciliationSaga(): Generator {
  // Watch for the specific action type
  yield takeLatest<GetReconciliationssAction>(
    GET_RECONCILIATION_ACTION_TYPE,
    getReconciliations,
  );
}

export default reconciliationSaga;
